<style lang="scss" scoped>
.slide-6 {
  background-image: url("../../../assets/module3/slide6/background-01.jpg");
  background-size: cover;
  background-position: center;
  height: calc(100% - 0px);

  .polaroid {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
  }

  .pages {
    z-index: 1;
    position: relative;
    padding-top: 100px;
  }
  .page-left {
    flex-basis: 65%;
  }
  .page-right {
    flex-basis: 35%;
  }

  .heading {
    transform: rotate(-5deg);
    margin-left: -60px;
    margin-top: -60px;
  }

  .heading1,
  .heading3,
  .heading4 {
    color: #edad0a;
  }
  .challenge {
    color: #fff;
    font-size: 1.5em;
  }
  .heading3 {
    margin-left: 60px;
  }
  .heading4 {
    margin-left: 120px;
  }
  .heading5 {
    color: #c5d43b;
    margin-top: 70px;
    font-size: 40px;
  }

  .copy-left {
    width: 600px;
    margin-top: 30px;
  }

  .share {
    width: 160px;
    margin-left: 150px;
  }
}
</style>

<template>
  <div class="slide-6">
    <div class="pages">
      <div class="page page-left">
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 5" class="heading delay-1">
            <div class="heading-text">
              <h1 class="heading1">
                {{ $t("module3.slide6.heading1") }}
                <span class="challenge">{{
                  $t("module3.slide6.heading2")
                }}</span>
              </h1>
              <h1 class="heading3" v-html="$t('module3.slide6.heading3')"></h1>
              <h1 class="heading4" v-html="$t('module3.slide6.heading4')"></h1>
            </div>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 5" class="delay-2">
            <h1 class="heading5" v-html="$t('module3.slide6.heading5')"></h1>
          </div>
        </transition>
        <transition name="fadeLeft" appear>
          <div v-show="slideIndex == 5" class="copy-left delay-3">
            <p class="copy" v-html="$t('module3.slide6.copy1')"></p>
            <p class="copy" v-html="$t('module3.slide6.copy2')"></p>
          </div>
        </transition>
      </div>

      <div class="page page-right">
        <transition name="fadeRight" appear>
          <p class="copy delay-2">{{ $t("module3.slide6.copy3") }}</p>
        </transition>
        <transition name="fadeRight" appear>
          <p class="copy delay-3">{{ $t("module3.slide6.copy4") }}</p>
        </transition>
        <transition name="fadeRight" appear>
          <p class="copy delay-4">{{ $t("module3.slide6.copy5") }}</p>
        </transition>
        <transition name="fadeRight" appear>
          <p class="copy delay-5">{{ $t("module3.slide6.copy6") }}</p>
        </transition>
      </div>
    </div>

    <transition name="" appear>
      <img
        class="delay-1 polaroid"
        v-show="slideIndex == 5"
        src="@/assets/module3/slide6/images-01.png"
      />
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showVideo: false
    };
  },
  props: ["slideIndex"]
};
</script>
